import { isWx } from '../report/nioapp-event-report/utils';
import { isInNioCNApp } from '@/util/platform/universal';
import { WX_CONFIG_FAILED } from './constants';
import * as WxTools from './wx';
import * as AppTools from './app';
import * as H5Tools from './h5';
import * as UniversalTools from './universal';

async function configShare(share) {
    if (isWx()) {
        return WxTools.configShare(share);
    }
}

async function hideMenuItems() {
    if (isWx()) {
        return WxTools.hideMenuItems();
    }
}

async function getLocation() {
    if (isWx()) {
        try {
            const res = await WxTools.getLocation();
            return res;
        } catch (e) {
            if (e && e.code === WX_CONFIG_FAILED) {
                console.log('wx config failed, try tencent geolocation');
                return H5Tools.getLocation();
            }
            throw e;
        }
    }
    if (isInNioCNApp()) {
        return AppTools.getLocation();
    }
    return H5Tools.getLocation();
}

function openURL(url) {
    if (isInNioCNApp()) {
        return UniversalTools.redirectToViewBridge(url);
    }
    return H5Tools.openURL(url);
}

function getLoginInfo(params) {
    if (isInNioCNApp()) {
        return AppTools.getLoginInfo(params);
    }
    return UniversalTools.getLoginInfo(params);
}

export { getLocation, configShare, hideMenuItems, openURL, getLoginInfo };

// Promise-based api



// WEBPACK FOOTER //
// ./src/util/platform/index.js